import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { ADDRESS, EMAIL, PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT, IMG } from "@/lib/site";

const CARDS = [
  { icon: Phone, label: "Call Us", value: PHONE_DISPLAY, href: PHONE_TEL, testid: "contact-phone-card" },
  { icon: Mail, label: "Email", value: EMAIL, href: `mailto:${EMAIL}`, testid: "contact-email-card" },
  { icon: MessageCircle, label: "WhatsApp", value: PHONE_DISPLAY, href: WA_DEFAULT, testid: "contact-whatsapp-card" },
  { icon: MapPin, label: "Visit Us", value: ADDRESS, href: null, testid: "contact-address-card" },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEO title="Contact Us" description="Contact D Travel Link, Thane West — call or WhatsApp +91 99872 69355, email sales@dtravellink.com, or request a custom quote online." />
      <PageHero image={IMG.beach2} overline="We Reply Within 2 Business Hours" title="Contact Us"
                description="Call, WhatsApp, email or drop your details below — a real travel expert from Thane will take it from there." />
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {CARDS.map((c) => {
              const inner = (
                <>
                  <span className="w-11 h-11 rounded-xl bg-sky-50 flex items-center justify-center"><c.icon className="w-5 h-5 text-skybrand" /></span>
                  <span className="mt-4 block text-xs font-bold tracking-[0.15em] uppercase text-slate-400">{c.label}</span>
                  <span className="mt-1 block font-heading font-bold text-slate-900">{c.value}</span>
                </>
              );
              const cls = "rounded-2xl bg-white border border-slate-200/80 p-6 shadow-sm hover:shadow-xl transition-shadow block h-full";
              return (
                <Reveal key={c.label}>
                  {c.href ? (
                    <a href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={c.testid} className={cls}>{inner}</a>
                  ) : (
                    <div data-testid={c.testid} className={cls}>{inner}</div>
                  )}
                </Reveal>
              );
            })}
          </div>

          <div className="mt-14 grid lg:grid-cols-2 gap-10 items-start">
            <Reveal>
              <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Request a Quote</h2>
              <p className="mt-3 text-slate-600 leading-relaxed">
                Tell us where you want to go and roughly when. We will revert with a detailed, transparent quotation — no obligation, no spam.
              </p>
              <ul className="mt-6 space-y-3 text-sm text-slate-600">
                <li>• All costing is on request — based on your dates, hotels and traveller count.</li>
                <li>• Every quote is itemised: flights, hotels, transfers, sightseeing, taxes.</li>
                <li>• Prefer talking? WhatsApp us any time — we are quick on chat.</li>
              </ul>
            </Reveal>
            <Reveal>
              <div className="rounded-2xl bg-white border border-slate-200/80 p-6 sm:p-8 shadow-sm">
                <EnquiryForm source="contact-page" />
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
